/* eslint-disable max-len */
module.exports = {
  menu: {
    home: 'Home',
    game: 'Game',
    connect_login: 'Connect/Login',
    new_game: 'New Game',
    invite_friends: 'Invite Friends',
    cms_login: 'CMS Login',
    login: 'Login',
    logout: 'Logout',
    login_to_play_game: 'Login to begin',
    select_login_method: 'Select Login Method',
    select_register_method: 'Select Register Method',
    email: 'Email',
    meta_mask: 'MetaMask',
    register: 'Register',
    player_login: 'Player Login',
    history: 'History',
    transaction_history: 'Transaction History',
    ranking: 'Ranking',
    purchase: 'Purchase',
    search_game_placeholder: 'Search game..',
    new_games: 'New Game',
    frequent: 'Freq. Game',
    faq: 'FAQ',
    terms_and_conditions: 'Win4Poker Terms and Conditions',
    tnc: 'Terms and Conditions',
    about_us: 'About Us',
    contact_us: 'Contact Us',
    settings: 'Settings',
    lucky_draw: 'Lucky Draw',
    tournament: 'Tournament',
    announcement: 'Announcement',
    no_news: 'No Announcement',
    online: 'Online',
    deposit: 'Deposit',
    terms_1_title: 'Eligibility Criteria',
    terms_1_content:
      'All players must be over 18 years old and play in regions where it is legally permitted to register and play.',
    terms_2_title: 'Account Registration',
    terms_2_content: 'Players must register an account through the official website.',
    terms_3_title: 'Game Rules',
    terms_3_content:
      'All games must follow standard poker rules, and any cheating behavior will result in the suspension or closure of the account.',
    terms_4_title: 'Deposits and Withdrawals',
    terms_4_content:
      "Players must use the platform's payment methods for deposits, and withdrawals will be processed according to the platform's handling time.",
    terms_5_title: 'Prize Distribution',
    terms_5_content:
      'Prizes will be distributed based on the game results, and the rules will be explained before the game starts.',
    terms_6_title: 'Limitation of Liability',
    terms_6_content:
      'The platform is not responsible for any loss or damage arising from the use of its services or products.',
    terms_7_title: 'Privacy Protection',
    terms_7_content:
      'Player personal information will be kept confidential and will only be used for account management and gaming purposes.',
    terms_8_title: 'Amendment of Terms',
    terms_8_content:
      'The platform reserves the right to modify the terms and conditions at any time, with updates communicated through email or website notices.',
  },
  common: {
    theme: 'Theme',
    delete_record_confirm_msg: 'Are you sure you want to delete?',
    yes: 'Yes',
    no: 'No',
    true: 'True',
    false: 'False',
    success: 'Success',
    loading: 'Loading',
    or: 'or',
    delete: 'Delete',
    login: 'Login',
    submit: 'Submit',
    apply: 'Apply',
    cancel: 'Cancel',
    confirm: 'Confirm',
    back_to_lobby: 'Back to Lobby',
    email: 'Email',
    id_document: 'ID Document',
    all_in_game: "All-In or Fold Hold'em",
    all_in_game_omaha: 'All-In or Fold PLO',
    regular: "Hold'em",
    regular_description: "Texas Hold'em is played with a no-limit betting",
    short: 'Short Deck',
    short_description: "Hold'em is played with a 36-card deck",
    omaha: 'PLO',
    omaha_description: 'Player must use 2 of their hole cards to build a hand',
    regular_allin: "All-In or Fold Hold'em",
    omaha_allin: 'All-In or Fold PLO',
    tournament: 'Tournament',
    start: 'Start',
    game_demo_area: 'Game Demo Zone',
    total_win_prize: 'Total Award',
    waiting_list_order: 'Waiting list order',
    join_more_than_4_room_error: 'Cannot join more than four room',
    system_message: 'System message',
    error: 'Error',
    register: 'Register',
    meta_mask: 'MetaMask',
    wallet_connect: 'Wallet Connect',
    password: 'Password',
    next_step: 'Next Step',
    next: 'Next',
    verify: 'Verify',
    copy_success: 'Copied',
    enabled: 'Enabled',
    enable: 'Enable',
    disable: 'Disable',
    done: 'Done',
    pop_up_content: 'Referral feature in progress, please check back soon',
    no_data: 'No Data Available',
    retry: 'Retry',
    location_restricted_title: 'Location Restricted',
    location_restricted_content:
      'Access from your current location is restricted. Certain features or services may be unavailable due to regional limitations. Thank you for your understanding.',
    dont_show_again: "Don't show again",
    edit: 'Edit',
    i_am_not_located_in_the_restricted_country: 'I am not located in the restricted country',
  },
  auth: {
    nickname: 'Nickname',
    connect_to_win_4_poker: 'Connect to WIN 4 POKER',
    wallet_connect_need_to_connect_ur_wallet: 'Dapp needs to connect to your wallet',
    wallet_connect_sign_this_message:
      'Please return to your wallet to sign the message and proceed. Canceling will disconnect you.',
    sign_request_in_wallet: 'Sign Request in Wallet',
    sign_message_success: 'Sign message success',
    cancel: 'Cancel',
    sign: 'Sign',
    confirm_password: 'Confirm Password',
    referral_code: 'Referral Code',
    i_have_read_the_agreement: 'I have read the agreement',
    should_accept_agreement: 'Should accept agreement',
    alphabet_validation: 'At least one alphabet character',
    numeric_validation: 'At least one number',
    length_validation: 'At least 8 characters, but no longer than 20 characters',
    placeholder: {
      enter_user_name: 'Enter user name',
      enter_email: 'Enter email',
      enter_password: 'Enter password',
      confirm_password: 'Confirm password',
      enter_referral_code: 'Enter referral code',
    },
    error_messages: {
      nickname: 'Please enter your nickname',
      email_invalid: 'This is an invalid email',
      email_required: 'Please enter your email',
      password_required: 'Please enter your password',
      password_confirm_required: 'Please confirm your password',
      password_confirm_not_matched: 'The two passwords that you entered do not match!',
      incorrect_email_or_password: 'Incorrect email or password',
      error_occurred: 'An error occurred, please try again later',
      missing_player_token: 'Missing player token',
      please_try_again: 'Please try again',
    },

    // login-email page
    forget_password: 'Forgot password?',

    // forgot-password page
    forgot_password_title: 'Forgot password',
    please_enter_email_registered: 'Please enter email you registered',

    // email-verification page
    email_verification: 'Email Verification',
    email_has_been_sent_to: 'Email has been sent to {{value}}',
    email_resend_countdown_message:
      "Didn't receive the email? You may request another email after <0>countdown</0> seconds",
    please_check_your_email: 'Please check your email',
    waiting_to_verify_email: 'Waiting to verify your email',
    agree_terms_and_privacy:
      'If you continue the procedure, which represents you have agreed to our <0>Terms</0> and <1>Privacy Policy</1>.',
    terms: 'Terms',
    privacy_policy: 'Privacy Policy',

    // metamask-complete-registration page
    complete_metamask_registration: 'Complete MetaMask Registration',

    // reset-password page
    reset_password: 'Reset Password',
    you_may_now_reset_password: 'You may now reset your password',

    register_an_account: 'Have no accounts? <0>Register</0> here!',
    resend_code_message: "Didn't receive the email? Click here to <0>Resend</0>",

    // 2FA setup page
    two_fa_via_email_title: 'Two-Step Verification via Email',
    otp_has_been_sent_to_email:
      'A one time authentication code has been sent to your register email.',
    two_factor_authentication: 'Two-Factor Authentication',
    scan_this_qr_code_msg:
      'To setup two-factor authentication (2FA), scan this QR code with an app like Authy or Google Authenticator.',
    choose_scan_qr_code_msg:
      'Open the authenticator app, tap the + icon on the bottom right. Choose Scan a QR code.',
    choose_enter_setup_key_msg:
      'Open the authenticator app, tap the + icon on the bottom right. Choose Enter a setup key.',
    secret_key: 'Secret key',
    enter_code_in_authenticator_app: 'Please enter the code shown in the authenticator app.',
    two_fa_is_set: {
      title: '2FA is set',
      message: 'You have setup 2FA, withdrawal function is now available.',
    },
    connect_wallet_to_spin: 'Connect Wallet',

    // enter code page
    link_email: 'Link Email',
    unlink_email: 'Unlink Email',
    expires_in: 'Expires in <0>min</0>.',
    resend_code: '<0>Resend code</0>',
    enter_code: 'Enter Code',
    unlink_email_confirm_msg: 'Are you sure you want to unlink your email?',
    link_success: 'Email linked successfully',
    unlink_success: 'Email unlinked successfully',
  },
  slider: {
    about: 'About',
    support: 'Support',
  },
  game_room: {
    confirm_leave_msg: 'Are you sure you want to leave the game?',
    join_room_error_title: 'Join room error',
    join_room_error_msg: 'Failed to join room, please try again',
    confirm_withdraw_extra_bet_msg: 'Are you sure you want to withdraw extra bet?',
    total_won_prize: 'Win in Total: ${{val, number}}',
    your_balance: 'Balance: ${{val, number}}',
    no_enough_balance: 'Your balance is lower than min buy-in: ${{val, number}}',
    cash_out: 'Collect Coins and Leave',
    continue_game: 'Continue the Game',
    remark_placeholder: 'Remarks',
    leave_seat: 'Sit out',
    sit_in: 'Sit In',
    buy_in: 'Buy In',
    buy_in_min_amount: 'Min',
    buy_in_max_amount: 'Max',
    seconds: 'seconds',
    close_drawer: 'Close',
    leave_game: 'Leave Game',
    back_to_lobby: 'Back to Lobby',
    leave_table: 'Leave Table',
    you_have_copied_room_code: 'You have copied room code: {{value}}',
    invitation_message:
      "Enter the game room {{roomNumber}} created by {{playerName}}. Let's get started!",
    link_copied: 'Link copied',
    please_wait_until_connected: 'Please wait until connected',
    rejoin_room: 'Back to Room',
    theme_setting: 'Theme setting',
    room_code_share: 'Copy room code',
    room_link_copy: 'Share room link',
    table_setting: 'Table setting',
    emoji_menu: 'Emoji menu',
    history_drawer: 'Room History Drawer',
    deposit: 'Deposit',
    withdraw_extra_bet: 'Withdraw Extra Bet',
    add_extra_bet: 'Add Extra Bet',
    unit_convert: 'Convert Unit',
    silent_mode_on: 'Silent Mode: On',
    silent_mode_off: 'Silent Mode: Off',
    raise_to: 'Raise to',
    winner: 'Win',
    player_status: {
      disconnected: 'Disconnected',
      sat_out: 'Sat out',
    },
    win_percentage: 'Win Percentage',
    all_in: 'All In',
    ping_popup_msg: 'Abnormal network connect, trying to reconnect',
    ping_popup_title: 'Abnormal Network Connection',
    ping_popup_content: 'Trying to reconnect, you may try refreshing the page',
    disconnected_modal_title: 'Abnormal Network Connection',
    afk_timer_text:
      "You have left the seat due to inactivity, if you don't return, you will be forced out of the room",
    regular: "Hold'em",
    short: 'Short Deck',
    omaha: 'PLO',
    omaha_all_in: 'All-In or Fold PLO',
    buyin_option: 'Buy In Option',
    buy_in_amount: 'Buy In Amount',
    reminder: 'Reminder',
    not_enough_balance_to_buy_in: 'You do not have enough balance to buy in.',
    sitting_out: 'Sitting out',
    not_leaving_temporarily: 'Not leaving temporarily',
    back_to_home: 'Back to Home',
    are_you_sure_leave_table:
      "You're the player with the highest bet, are you sure you want to quit?",
    leave_table_with_highest_bet_error:
      "You're the player with the highest bet, you can't leave the table. Please try again later",
    loading_room_data: 'Loading room data...',
    sit_out_tournament_warning: {
      title: 'Sit out tournament warning',
      msg: 'You are currently in a tournament. If you sit out, you will still need to pay for blinds.',
    },
  },
  player_action: {
    bet: 'BET',
    call: 'CALL',
    check: 'CHECK',
    raise: 'RAISE',
    fold: 'FOLD',
    bb: 'BB',
    sb: 'SB',
    ante: 'Ante',
    all_in: 'ALL IN',
    insurance_cancel: 'CANCEL INSURANCE',
    insurance_buy: 'BUY INSURANCE',
  },
  game_demo: {
    experience_progress: 'Experience Code Progress',
    game_experience_zone: 'Game Experience Zone',
    action_to_redemption: 'Play 30 games to exchange game code',
    remaining_game_experience_code: '{{val, number}} remains',
    cash_code_exchange: 'Cash Code Exchange',
    successfully_finish_30_games: 'Successfully Finished',
    congrats: 'Congratulations!',
    successful_exchange_cash_code: 'Successfully exchanged for {{amount}} cash code',
    how_to_redeem: 'How to exchange the experience code for cash code',
    successful_condition_of_redemption: 'Condition: Achieve 30 valid games',
    two_to_three_players: '2-3 players',
    explanation_of_valid_game: 'When you reach 10BB & endgame, it counts as a valid match.',
    more_than_four_players: '4 players or above',
  },
  userProfile: {
    profile_settings: 'Profile Settings',
    initial_setting_title: 'Welcome to Win4.Poker',
    initial_setting_description: 'Please finish the initial setting below and enjoy our games',
    display_name: 'Display Name',
    profile_picture: 'Profile Picture',
    edit: 'Edit',
    balance: 'Balance',
    coin: 'USD',
    demo_coin: 'Demo Coin',
    diamond: 'Diamond',
    game_record: 'Game Record',
    ranking_list: 'Ranking',
    game_review: 'Game Review',
    shortcut_setting: 'Shortcut Setting',
    user_name: 'Username: ',
    recommend_code: 'Code',
    upload_image_msg: 'Drag & drop image here, or using ',
    upload_image_browser_msg: 'browser',
    upload_image_file_size: '(File Size Max: 68px*93px)',
    username_length_message: 'Username should be between 3-24 characters',
    chinese_username_length_message:
      'Username containing Chinese character should be between 1-5 characters',
    username_char_message:
      "Username should be alphanumerical, Chinese characters and '_', '-', '.' only",
    personal_information: 'Personal Information',
    user_icon: 'Icon: ',
    save: 'Save',
    my_profile: 'My Profile',
    my_balance: 'My Balance',
    deposit_withdraw: 'Deposit/Withdraw',
    my_record: 'My Record',
    flow_record: 'Flow Record',
    total_earnings: 'Total Earnings',
    country: 'Country',
    events: 'Events',
    disclaimer: 'Disclaimer',
  },
  maintenance: {
    title: 'Site is under maintenance',
    content:
      "We're working hard to improve the user experience. We will be back shortly. Thank you for your patience.",
  },
  useSetting: {
    card_front: 'Card Front',
    card_back: 'Card Back',
    table: 'Table',
    add_token_msg: 'Do you need to add more token coins?',
    invite_friends_description: 'Invite friends to join Win4Poker and get rewards',
    whatsapp_referral_message:
      "Who's ready to bluff and win? 🃏 Join me on Win4Poker for some epic games! Here's my invite: ",
    number_of_referrals: 'Number of Referrals',
    my_commission: 'My Commission',
  },
  lucky_draw: {
    award_history: 'Award Record',
    lucky_draw_rules: 'Rules',
    remaining_lucky_draw_amount: 'Spins left: {{value}}',
    remaining_lucky_draw_amount_loading_label: 'Spins left: ',
    spin_wheel_10_times: 'Spin Ten Times',
    spin_wheel: 'Spin',
    participation_rate: 'Game Participation Rate: {{count}}',
    coin_loss: 'Game Participation Rate',
    congrats: 'Congratulations!',
    you_have_won: 'You have won ${{prize}}',
    collect_prize: 'Collect Prize',
    select_category: 'Select Draw Category: ',
    special_combination: 'Special Combination: ',
    no_history: 'No Draw History is Found',
    no_data: 'No Data Available',
    spin: 'Spin',
    fortune_wheel: 'Fortune Wheel',
    christmas_fortune_wheel: 'Christmas Fortune Wheel',
    new_year_fortune_wheel: 'New Year Fortune Wheel',
    cny_fortune_wheel: 'Chinese New Year Fortune Wheel',
    email_login: 'Email Login',
    thank_you: 'Thank you',
    miss_msg_1:
      'Thank you for participating in our event, you have no spins left, you can join our game to win more money. Enjoy and Good Luck.',
    play_now: 'Play Now',
    win_msg: 'You have won <br/> <large>{{prize}}</large> <br /> and was saved to your balance.',
    diamond: '{{value}} Diamond',
    draw_again_msg:
      'You have <yellow>{{numOfDraws}}</yellow> draws left. <clickable>Click to draw again.</clickable>',
    redeem_now: 'Redeem Now',

    deposit_more_than_10: 'DEPOSIT MORE THAN $10',
    get_1_free_spin: 'GET 1 FREE SPIN',
    win_10_times: 'WIN 10 TIMES',
  },
  combination: {
    hi_card: 'High Card',
    pair: 'One Pair',
    one_pair: 'One Pair',
    two_pairs: 'Two Pairs',
    set: 'Three of a Kind',
    three_of_a_kind: 'Three of a Kind',
    straight: 'Straight',
    flush: 'Flush',
    fullHouse: 'Full House',
    full_house: 'Full House',
    quad: 'Four of a Kind',
    straight_flush: 'Straight Flush',
    royal_flush: 'Royal Flush',
  },
  room_type: {
    public: 'Public Room',
    private: 'Private Room',
  },
  forgot_password: {
    reset_password: 'Reset password',
    password: 'Password',
    confirm_password: 'Confirm password',
    phone: 'Phone',
  },
  error: {
    please_confirm: 'Please confirm',
    password_inconsistent: 'Password inconsistent',
    file_size_limit_error: 'Maximum upload file size is {{size}}',
    please_input: 'Please input {{field}}',
  },
  translation: {
    success: '成功',
  },
  game_list: {
    table: ' Table',
    random_join_table: 'Join random table',
    random_join: 'Random Join',
    join: 'Join',
    no_room_available: 'No room available. Please come back again later.',
    all_game_loaded: 'All games have been loaded',
    join_waiting_list: 'Join waiting list',
    join_table: 'Join table',
    join_observer: 'Observe table',
    game_code: 'Code',
    game_type: 'Type',
    game_limit: 'Limit',
    game_players: 'Players',
    game_unit_test: 'Unit Test',
    game_basicBet: 'Basic Bet',
    game_SB: 'SB',
    game_smallBlind: 'Small Blind',
    regular: "Hold'em",
    all_in: "All-In or Fold Hold'em",
    short: 'Short Deck',
    omaha: 'PLO',
    omaha_all_in: 'All-In or Fold PLO',
    buy_in: 'Buy in',
    notice: 'Reminder',
    time_difference_reminder:
      'An unusual discrepancy between your system time and internet time, which may affect the functionality of the player countdown feature. Please synchronize your system time as soon as possible',
    player_category: 'By Player',
    blind_category: 'By Blind',
    table_category: 'By Table',
    chips: 'Chips',
    player: 'Player',
    waiting: 'Waiting',
    avg_pot: 'Avg. Pot',
    flop_rate: 'Flop Rate',
    hands_per_hour: 'Hands/Hour',
    no_of_hands_played: 'Hands Played',
    win: 'Win',
    invested: 'Invested',
    pot: 'Pot',
    all_in_regular: "A/F Hold'em",
    all_in_omaha: 'A/F PLO',
    usd_balance_updated: 'USD balance updated to ${{balance}}',
    new_room: 'New Room',
    game: 'Game',
    tournament: 'Tournament',
  },
  game_review: {
    my_bets: 'My Bets',
    date_range: 'Date Range',
    select_date_range: 'Select Date Range',
    show_all_dates: 'Show All Dates',
    show_selected_dates: 'Show Selected Dates',
    no_game_record: 'No Game Record',
    ante: 'Ante',
    win_row_message: 'WIN!!',
    lose_row_message: 'Invested',
    win: 'WIN',
    lose: 'LOSE',
    main_pot: 'Main Pot',
    side_pot: 'Side Pot {{number}}',
  },
  leader_board: {
    rank: 'Rank',
    name: 'Name',
    win_game: 'Cumulative Wins',
    score: 'Score',
  },
  home: {
    dont_miss_promotion_msg: "Don't miss out",
    all_promotions: 'All promotions',
    my_game: 'My Game',
    all_games: 'All Games',
    claim_first_time_reward_button: 'Understand',
    first_time_login: 'First time login to PGame,',
    first_time_reward_msg: 'you will get {{val}} demo-coin.',
    open_table: 'Open Table',
    open_new_room: 'Create New Room',
    enter_room_number: 'Enter Room Code',
    start: 'Create Room',
    enter_code: 'Enter Code',
    confirm: 'Confirm',
    game_selection: 'Game Selection',
    start_game: 'Start game/Join table',
    game_record: 'Game Record',
    join_private_room: 'Join Private Room',
    roomCode: 'room code',
    please_enter_a_valid_room_code: 'Please enter a valid room code',
    notice: 'Reminder',
    time_difference_reminder:
      'An unusual discrepancy between your system time and internet time is detected, which may affect the countdown feature for players. Kindly synchronize your system time as soon as possible. If already synchronized, please refresh the page.',
    register_success: 'Register Success',
    referral_code: 'Referral Code',
    referral_code_placeholder: 'Enter Referral Code',
    display_name: 'Display Name',
    display_name_placeholder: 'Enter Display Name',
    user: 'User',
    bet_amount: 'Bet Amount',
    date: 'Date',
    multiplier: 'Multiplier',
    payout: 'Payout',
    free_game: 'Free Game',
    play_without_money: 'Play without money',
    private_game: 'Private Game',
    play_with_friends: 'Play with friends',
    regular_content: "Texas Hold'em is played with a no-limit betting",
    all_in_content: "All-In or Fold Hold'em is played with a no-limit betting",
    short_content: 'Short Deck is played with a no-limit betting',
    omaha_content: 'Pot Limit Omaha is played with a no-limit betting',
    omaha_all_in_content: 'All-In or Fold PLO is played with a no-limit betting',
    player_statistics: 'Player Statistics',
    lucky_draw_reminder: {
      title: 'Reminder',
      message: 'You have {{value}} lucky-draw spins left',
      go_to_lucky_draw: 'Go to Lucky Draw',
      spin_now: 'Spin Now',
    },
  },
  disclaimer: {
    title: 'Disclaimer',
    message:
      'If you live in the following restricted territories, you are not allowed to play on win4.poker',
    countryList:
      'USA, Turkey, Aruba, Bonaire, Curacao, France, Netherlands, Sweden, Israel, Lithuania, Slovakia, Belgium, Switzerland, Saba, St Eustatius, St Martin, China, United Kingdoms.',
    checkbox_message:
      "I confirm gambling isn't forbidden by my local authorities and I'm at least 18 years old.",
    required_message: 'Please agree the disclaimer',
  },
  login: {
    user_account: 'User account',
    password: 'Password',
    cash_web_login: 'Cash website login',
    player_register: 'Player Register',
    gateway_user_name: 'Gateway User Name',
    cms_login: 'CMS Login',
    deposit: 'Deposit',
    deposit_amount: 'Deposit Amount',
    deposit_message: 'Deposit amount is required',
    notice: 'Reminder',
    duplicate_login: 'Detected multiple logins from the same IP',
    redirecting: 'You will be redirected shortly. Please wait...',
    loading: 'Loading resources, please wait...',
  },
  verification: {
    email_verification_code: 'Email verification code',
    email_not_verify_error: 'Email not verify',
    confirm: 'Confirm',
    timer_count: 'Timer count',
    resend_verification_code: 'Resend verification code',
    send_verification_code: 'Send verification code',
    input_field: 'Enter {{field}}',
    code: 'code',
    successful_verify: 'Successful Verify',
    two_factor_authentication: 'Two-factor authentication',
    verification: 'Verification',

    // KYC page
    verify: 'Verify',
    security: 'Security',

    kyc_status: {
      failed_verify_again: 'Failed, Verify Again',
      under_review: 'Under Review',
      verify_now: 'Verify Now',
    },

    complete_email_verification_to_unlock_some_function:
      'Complete Email Verification to unlock XXX function',
    complete_id_verification_to_upgrade_withdrawal_amount:
      'Complete Identity Verification to upgrade withdrawal amount to 100,000 USDT',
    requirement: 'Requirement',
    verify_now: 'Verify Now',

    verification_code: 'Verification Code',
    email_verification: {
      title: 'Email Verification',
      msg: 'Please enter an email address which can receive verification code.',
      otp_has_been_sent_to: 'An one time authentication code has been sent to {{value}}',
    },

    id_card: 'ID Card',
    passport: 'Passport',

    identity_verification: {
      title: 'Identity Verification',
      msg: 'Please use valid identification document for identity verification.',
      issuing_country: {title: 'Select document issuing country', placeholder: 'Select Country'},
      document_type: {
        title: 'Select identification document type',
        placeholder: 'Select Identification Document Type',
      },
    },

    uploadDocument: {
      title: 'Upload Document',
      make_sure_that_your: 'Make sure that your document:',
      is_clear_and_easy_to_read: 'is clear and easy to read',
      is_unedited: 'is unedited',
      the_whole_doc_must_appear_in_photo: 'the whole document must appear in the photo',
      no_reflective_glare: 'there is no reflective glare',

      upload_image: 'Upload Image',
      upload_image_requirement: 'File size must be less than 10MB in jpeg or png format.',
      front_side_of_id: 'Front side of ID',
      back_side_of_id: 'Back side of ID',
      personal_data_page_of_passport: 'Personal data page of Passport',
      document_uploaded: 'Document Uploaded',
      id_document_under_review_msg:
        'Your identification document is under review, it may take 1-2 working days to complete the verification.',
    },

    disable_2fa: {
      title: 'Disable 2FA',
      description:
        "To continue, first verify it's you by entering the authentication code from your authenticator app",
      success_message: 'You have disabled 2FA',
    },

    error_messages: {
      document_upload_required: 'Please upload document',
      selection_required: 'Please select an option',
    },
  },
  table_area: {
    pot: 'Pot',
    waiting_for_other_players: 'Waiting for other players',
    waiting_for_game_start: 'Waiting for game to start',
    sixty_sec: '60s',
    please_select_emoji_target: 'Please select player',
  },
  best_combination: {
    hi_card: 'High Card ({{value}})',
    one_pair: 'One Pair ({{value}})',
    two_pairs: 'Two Pairs ({{firstPair}}, {{secondPair}})',
    set: 'Three of a Kind ({{value}})',
    straight: 'Straight (from {{fromValue}} to {{toValue}})',
    flush: 'Flush ({{value}} high)',
    fullHouse: 'Full House ({{three_cards}} , {{two_cards}})',
    quad: 'Four of a Kind ({{value}})',
    straight_flush: 'Straight Flush (from {{fromValue}} to {{toValue}})',
    royal_flush: 'Royal Flush',
  },
  action_buttons: {
    place_bet: 'Bet',
    all_in: 'All In',
    bet: 'Bet',
    check: 'Check',
    call: 'Call',
    raise: 'Raise',
    fold: 'Fold',
    pot: 'Pot',
    confirm: 'Confirm',
    investment: 'Investment',
    insurance: 'Insurance',
    choosing_cards: 'Cards',
    outs_number: 'Outs number',
    insurance_winning_rate: 'Winning Rate',
    odds: 'Odds',
    premium: 'Premium',
    payout: 'Payout',
    call_any: 'Call Any',
    wait_for_blinds: 'Wait For Blinds',
    join_directly: 'Join Directly',
    check_or_fold: 'Check / Fold',
    confirm_to_fold: 'Are you sure you want to Fold?',
    max: 'Max',
    min: 'Min',
    force_insurance: 'Force Insurance',
  },
  history_drawer: {
    title: 'Room History',
    small_blind: 'Small Blind',
    pre_flop: 'Pre-Flop',
    flop: 'Flop',
    turn: 'Turn',
    river: 'River',
    no_data: 'No room Data',
    hands: 'Hands',
    winner: 'Winner',
    buy_in: 'Buy In',
    pool: 'Pot',
    win_player: 'Win Player',
    time: 'Time',
    main_pot: 'MAIN POT',
    side_pot_one: 'SIDE POT 1',
    side_pot_two: 'SIDE POT 2',
    side_pot_three: 'SIDE POT 3',
    win: 'Wins',
    loading: 'Loading',
    all_record_loaded: 'All record have been loaded',
    previous_page: 'Previous',
    close: 'Close',
    detail: 'Detail',
  },
  file_upload: {
    upload: 'Upload',
  },
  user_menu: {
    two_factor: 'Two-factor authentication',
    change_password: 'Change password',
    logout: 'Logout',
    hello_user: 'Hello',
  },
  change_password_board: {
    change_password: 'Change password',
    old_password: 'Old password',
    new_password: 'New password',
    confirm_password: 'Confirm password',
  },
  list_page: {
    export_title: '',
    export_info: '',
    search_bar_placeholder: 'Search..',
    filter: 'Filter',
    confirm_to_export: '',
    create_board: '',
    update_board: '',
  },
  permission_assigner: {
    read: 'Read',
    write: 'Write',
    none: 'None',
    banned: 'Banned',
  },
  phone_input: {
    invalid_country_code: 'Invalid Country Code',
    invalid_phone: 'Invalid Phone',
    phone_number: 'Phone Number',
    phone_code: 'Phone Code',
  },
  room_setting_drawer: {
    create_new_room: 'Create New Room',
    enter_room_code: 'Enter Room Code',
    enter_room: 'Enter Room',
    room_setting: 'Room Setting',
    small_blind: 'Small Blind:',
    please_enter_a_valid_room_code: 'Please enter a valid room code',
    please_input_room_code: 'Please input room code',
    ante: 'Ante:',
    buy_in: 'Buy-in:',
    number_of_people: 'Number of Player:',
    action_time: 'Action Time:',
    game_duration: 'Game Duration:',
    commission: 'Commision:',
    insurance: 'Insurance:',
    location_restriction: 'Location Restriction',
    diamond_needed: 'Diamond Needed:',
    diamond_owned: 'Diamond Owned:',
    redeem: 'Buy Diamond',
    open_room: 'Create Room',
    maximum: 'Maximum:',
    hours: '{{value}}hrs',
    minute: '{{value}}mins',
    second: '{{value}}s',
    affect_diamond_needed: 'Affect Diamond Needed',
    remaining_room_time: 'Remaining room time',
    diamond_require: 'Diamond require:',
    time_increase: 'Extend time:',
    recharge: 'Recharge',
    isAllIn: 'All In',
    ipchecking: 'IP Restriction',
    diamond_not_enough: 'Insufficient diamond',
  },
  gameRecharge: {
    sticker_title: 'Sticker',
    check_for_more: 'View more',
    diamond_title: 'Diamond',
    diamond_product_tag: '{{value}} Diamonds',
    buy_diamond_confirm_msg: 'Purchase Confirm',
    buy_sticker_confirm_msg: 'Are you sure you want to buy this sticker?',
    balance_not_enough_msg: 'Balance is not enough',
    sticker_product_tag: '{{value}} Diamonds',
    confirm_to_buy_button: 'Confirm',
    confirm_title: 'Confirm Redeem',
    confirm_message:
      'Do you confirm to redeem <1>{{diamondAmount}} diamond</1> for USD$ <0>{{usdAmount}}</0>？',
    redeem: 'Redeem',
    confirm: 'Confirm',
    reminder: 'Reminder',
    not_enough_money: "Sorry, you don't have enough balance to recharge.",
    not_enough_diamond: 'Sorry, you do not have enough diamond to purchase.',
    quanity: 'Quanity:',
    price: 'Price:',
    diamond: 'Diamond',
    sticker: 'Sticker',
    purchase_success: 'Purchase Success',
    purchase: 'Purchase',
    diamond_balance: 'Diamond Balance',
    free_sticker: 'This sticker is for free',
    amount_required: 'Amount is required',
    valid_amount: 'Please enter a valid amount',
    not_enough_diamond_balance: 'Not enough diamond balance',
  },
  transactionRecord: {
    transactionCurrencyType: {
      all: 'All',
      usd: 'USD',
      cash: 'Cash Code',
      diamond: 'Diamond',
    },
    transactionType: {
      createRoom: 'Create private room',
      luckyDraw: 'Play lucky-draw wheel',
      purchaseItem: 'Purchase sticker(s)',
      purchaseDiamond: 'Purchase {{value}} diamond(s)',
      joinGame: 'Joined {{value}} Poker',
      winGame: 'Win {{value}} Poker',
      loseGame: 'Lose {{value}} Poker',
      winGameWithoutGameType: 'Win a game',
      loseGameWithoutGameType: 'Lose a game',
      joinGameWithoutGameType: 'Joined a game',
      deposit: 'Deposit',
      redeemDemo: 'Exchange coin',
      insurance: 'Insurance',
      gift: 'Gift',
      firstLogin: 'First-time Login',
      privateRoomRebate: 'Private Room Rebate',
    },
    transactionRecord: 'Transaction Record',
    no_transaction_record: 'No transaction record',
    currentMonth: 'Current Month',
  },
  emojiPanel: {
    buy_sticker_confirm_msg: 'Are you sure you want to buy this sticker?',
    sticker_product_tag: '{{value}} Diamonds',
    confirm_to_buy_button: 'Confirm to Buy',
    emoji: 'Emoji',
    free: 'Free',
    no_available_emoji: 'No available stickers',
  },
  playerInfo: {
    button: 'Dealer',
    smallBlind: 'SB',
    bigBlind: 'BB',
    cutOff: 'Cut Off',
    underTheGun: 'UTG',
    bet: 'Bet',
    check: 'Check',
    call: 'Call',
    raise: 'Raise',
    fold: 'Fold',
    cancelInsurance: 'Cancel\nInsurance',
    confirmInsurance: 'Confirm\nInsurance',
    allIn: 'All In',
  },
  deposit_withdraw: {
    currency_usdt: 'Tether (USDT)',
    deposit_method: 'Deposit Method',
    remark: 'Remark',
    ton_connect: 'TON Connect',
    manual_deposit: 'Manual Deposit',
    usdt: 'USDT',
    eth: 'ETH',
    btc: 'BTC',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    withdrawal: 'Withdraw',
    history: 'History',
    blockchain: 'Blockchain',
    currency: 'Currency',
    network: 'Network',
    exchange_rate: 'Exchange Rate',
    deposit_address: 'Deposit Address',
    deposit_process_message_1:
      'The system will deposit immediately after receiving the money. It may take up to 2 hours, please wait patiently.',
    back: 'Back',
    address: 'Address',
    transaction_id: 'Transaction ID',
    amount: 'Amount',
    time: 'Time',
    coin_type: 'Coin Type',
    available_amount: 'Available Amount',
    withdraw_amount: 'Withdraw Amount',
    withdraw_cost: 'Withdraw Cost',
    receiving_amount: 'Receiving Amount',
    deposit_amount: 'Deposit Amount',
    deposit_amount_placeholder: 'Please enter the deposit amount',
    no_data: 'No Data Available',
    address_placeholder: 'Enter address',
    amount_placeholder: 'Enter amount',
    withdrawal_amount: 'Withdrawal Amount',
    withdrawal_fee: 'Withdrawal Fee',
    max: 'Max',
    available_cash_out_balance: 'Available Cash-out Balance',
    cash_out_info:
      'After buying into the pool, you can only withdraw the USDT you win, or if you draw in the poker game',
    wallet_balance: 'Wallet Balance',
    deposit_pending_title: 'Deposit Pending',
    deposit_pending_description: 'Your deposit is currently pending approval',
    deposit_success_title: 'Deposit Successful',
    deposit_success_description: 'Funds have been credited to your account',
    create_withdraw_success_title: 'Withdrawal Request Successful',
    create_withdraw_success_description: 'Your withdrawal request is being processed',
    withdrawal_success_title: 'Withdrawal Successful',
    withdrawal_success_description: 'Your withdrawal request has been completed',
    amount_required: 'Amount is required',
    amount_exceeds_available: 'Amount exceeds available balance',
    amount_below_minimum: 'Amount is below minimum',
    amount_below_fee: 'Amount is below fee',
    invalid_number: 'Invalid number',
    network_required: 'Network is required',
    address_required: 'Address is required',
    blockchain_required: 'Blockchain is required',
    email_required: 'Email is required',
    valid_amount: 'Please enter a valid amount',
    notice: 'Notice',
    cancel: 'Cancel',
    cancel_transaction: 'Transaction cancelled',

    from: 'From',
    receive_amount: 'Receive Amount',

    // 2FA
    two_fa_required_msg: 'For security, 2-factor verification must be setup before withdrawal.',
    setup_2fa: 'Setup 2FA',
    lost_my_2fa_access: 'Lost my 2FA access',

    wallets_usdt_token: "Wallet's USDT Token",
    memo_reminder_1:
      'Ensure {{memo}} is entered in the remark section to avoid potential loss of funds.',
    memo_reminder_2: 'If using TonConnect, the system will automatically fill it in.',

    wait_for_next_lucky_draw:
      'Please wait for the next lucky draw event for a chance to receive funds to play.',
  },
  history_status: {
    completed: 'Completed',
    pending: 'Pending',
  },
  transaction_history: {
    tab_titles: {
      all_flow: 'All Flow',
      deposits: 'Deposits',
      withdrawals: 'Withdrawals',
      bets: 'Bets',
      purchase: 'Purchase',
      diamond: 'Diamond',
    },

    transaction_type: 'Transaction Type',
    transaction_types: {
      deposits: 'Deposits',
      withdrawals: 'Withdrawals',
      bets: 'Bets',
      purchase: 'Purchase',
      purchase_item: 'Purchase Item',
      diamond: 'Diamond',
      referral_commission: 'Referral Commission',
      payout: 'Payout',
      private_room: 'Private Room',
      private_room_rebate: 'Private Room Rebate',
      reward: 'Reward',
      lucky_draw: 'Lucky Draw',
      tournament_ticket_fee: 'Tournament Ticket Fee',
      tournament_prize: 'Tournament Prize',
    },

    game_type: 'Game Type',
    type: 'Type',
    bet: 'Bet',
    payout: 'Payout',

    quantity: 'Quantity',
    amount: 'Amount',
    balance: 'Balance',
    diamond: 'Diamond',
    sticker: 'Sticker',
  },
  referral: {
    referral: 'Referral',
    invite_friends_description: 'Invite friends to join Win4Poker and get rewards',
    whatsapp_referral_message:
      "Who's ready to bluff and win? 🃏 Join me on Win4Poker for some epic games! Here's my invite: ",
    number_of_referrals: 'Number of Referrals',
    my_commission: 'My Commission',
    referral_rewards: 'Referral Rewards',
    referral_code: 'Referral Code',
    referral_link: 'Referral Link',
    enter_code: 'Enter Code',
    terms_and_conditions: 'Win4Poker Referral Program Terms',
    invite_friends: 'Invite Friends',
    pop_up_title: 'Notice',
    back_home: 'Back',
    scan_qr_code: 'Scan QR Code',
    code: 'Code',
    copy_link: 'Copy Link',
    save_image: 'Save Image',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    more: 'More',
    referral_history: 'Referral History',
    register_time: 'Register Time',
    player: 'Player',
    reward_time: 'Reward Time',
    reward_amount: 'Reward Amount',
    referral_list: 'Referral List',
    enter: 'Enter',
    skip: 'Skip',
    please_input_referral_code: 'Please input referral code',
    enter_referral_code: 'Enter Referral Code',
    enter_referral_code_success: 'Enter Referral Code Success',
    cannot_use_own_referral_code: 'Cannot use own referral code',
    total: 'Total',
    referral_code_invalid: 'Referral code invalid',
    commission: 'Commission',
    reward_type: 'Reward Type',
    amount: 'Amount',
    commission_reward: 'Commission Reward',
    commission_update_success: 'Commission update success',
    commission_setting: 'Commission Setting',
    save: 'Save',

    // title
    promotion_1: 'Promotion 1: Deposit Bonus',
    promotion_2: 'Promotion 2: Referral Code Reward',
    general_terms: 'General Terms and Conditions',

    // sub-title
    eligibility: 'Eligibility',
    offer: 'Offer',
    conditions: 'Conditions',
    program_duration: 'Program Duration',
    account_verification: 'Account Verification',
    limitations: 'Limitations',
    modification_of_terms: 'Modification of Terms',
    compliance: 'Compliance',
    support: 'Support',

    error_messages: {
      referral_code_invalid:
        'Referral code must be 4 to 8 characters long, can only contain alphanumeric characters excluding "I" and "O"',
      referral_code_required: 'Referral code is required',
    },

    commission_calculation: {
      title: 'Commission Calculation',
      first_layer: '1st Layer %',
      second_layer: '2nd Layer %',
      third_layer: '3rd Layer %',
      refers: 'Refers',
      referrer: 'Referrer',
      content:
        'The 5% of the winnings will be deducted as a commission. The gateway will receive 30% of the commission in <0>MAX</0>. The gateway will distribute the remain 70% of the commission to the top-level referrer, who can then decide to allocate Z% out of 70% of the commission to the next level of referrers. The next-level referrer can subsequently decide to distribute Y% out of  Z% of the commission to the level below them, and this process continues until the commission reaches the winner referrer.',
      example: {
        title: 'Example:',
        winner_wins: 'Winner Wins: ${{value}}',
        total_commission: 'Total Commission: ${{value}}',
        gateway_total_commission_max: 'Gateway Total Commission (MAX): ${{value}}',
        referral_total_commission_min: 'Referral Total Commission (MIN): ${{value}}',

        referral_commissions: 'Referral Commissions (70 ≥ Z ≥ Y ≥ X ...):',
        referrer_1_commission: 'Referrer 1: ${{totalCommission}} × (Z% - Y%)',
        referrer_2_commission: 'Referrer 2: ${{totalCommission}} × (Y% - X%)',
        referrer_3_commission: 'Referrer 3: ${{totalCommission}} × X%',
      },
    },

    // points
    eligibility_1: 'Users must deposit more than 1 USDT into their Win4.Poker account.',
    offer_1: 'Eligible users will receive a free gift of 1 USDT credited to their account.',
    conditions_1: 'This offer is unlimited.',
    conditions_2:
      'The deposit must be completed during the promotional period specified by Win4.Poker.',
    conditions_3: 'Users must have a verified account to qualify for this promotion.',

    eligibility_2: 'Users must refer friends using their unique referral code.',
    offer_2:
      'When a referred friend plays their first game, the referrer will receive a reward of 3.5% of the total pot in the max.',
    conditions_4: "The referred friend must register using the referrer's code.",
    conditions_5:
      'The reward will be distributed 2 hours after the referred friend completes their game.',
    conditions_6: 'Users can track their referrals and rewards through their account dashboard.',
    program_duration_1:
      'These promotions will run for a specified period, which will be communicated on our website and through official channels.',
    account_verification_1:
      'Participants must have a fully verified account to be eligible for any rewards.',
    limitations_1:
      'Users found to be abusing the referral system (e.g., self-referrals) may have their accounts suspended or banned.',
    modification_of_terms_1:
      'Win4.Poker reserves the right to modify or terminate these promotions at any time without prior notice.',
    compliance_1:
      'Participants must adhere to all applicable laws and regulations governing online gaming and promotions in their jurisdiction.',
    support_1:
      'Please contact our customer support team for questions or assistance regarding the referral program.',

    // disclaimer
    disclaimer: 'Disclaimer',
    disclaimer_1:
      'All rewards are subject to availability and may vary based on account status and activity. ',
    disclaimer_2:
      'Win4.Poker is not responsible for any technical issues that may prevent the successful tracking of referrals or rewards. ',

    fixed_commission: 'Fixed Commission',
    custom_commission: 'Custom Commission',
    invalid_commission_percentage: 'Invalid commission percentage',
    commission_placeholder: 'Enter commission percentage',
    my_share: 'My Share',
  },
  ranking: {
    ranking: 'Ranking',
    today: 'Today',
    this_week: 'This Week',
    this_month: 'This Month',
  },
  tournament: {
    you_have_won: 'You have won',
    time_elapsed: 'Time Elapsed',
    prize_pool: 'Prize Pool',
    entries: 'Entries',
    of: 'of',
    congratulations: 'Congratulations',
    thanks_for_your_joining: 'Thanks for your participation',
    watch: 'Watch',
    see_result: 'See Result',
    view_tournament: 'View Tournament',
    deregister: 'Deregister',
    start_in: 'Starts in <0>countdown</0>',
    full: 'Full',
    register_end_in: 'Register ends in <0>countdown</0>',
    my_ranking: 'My Ranking',
    players: 'Players',
    register: 'Register',
    pay_for_registration: 'Pay {{ticketFee}} for Registration',
    register_confirmation_message:
      'To register the tournament, {{ticketFee}} ticket fee would be charged, do you want to register {{tournamentName}}?',
    late_register: 'Late Register',
    level: 'Level',
    blinds: 'Blinds (SB/BB)',
    ante: 'Ante',
    duration: 'Duration',
    game_rule: 'Game Rule',
    game_mode: 'Game Mode',
    speed: 'Speed',
    general_information: 'General Information',
    ticket_fee: 'Ticket Fee',
    starting_stack: 'Starting Stack',
    blinds_start: 'Blinds Start',
    ante_starts: 'Ante Starts',
    raised_every: 'Raised Every',
    minutes: 'minutes',
    prize: 'Prize',
    structure: 'Structure',
    gameModeTitle: {
      classic: 'Classic',
      turbo: 'Turbo',
      hyper: 'Hyper',
    },
    gameModeDescription: {
      classic:
        'Classic multi-table tournament where entrants compete to win a share of the total prize pool.',
    },
    speedTitle: {
      regular: 'Regular',
      turbo: 'Turbo',
      hyper: 'Hyper',
    },
    speedDescription: 'Blinds increase every {{value}} minutes',
    tournament: 'Tournament',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    upcoming: 'Upcoming',
    results: 'Results',
    on_going: 'On Going',
    title: 'Tournament Details',
    tables: 'Tables',
    minutes_short: 'min',
    current_blinds: 'Current Blinds',
    next_blind_at: 'Next Blind At',
    start_game_in: 'Starts In',
    no_tournaments_available: 'No tournaments available',
    you_have_not_participated_in_any_tournament_yet:
      'You have not participated in any tournament yet',
    tournament_started: 'Tournament Started',
    tournament_ended_msg: 'Tournament Ended',
    tournament_canceled_msg: 'Tournament Canceled',
    view_table: 'View Table',
    view_player_table: 'View Player Table',
    table_rebalancing: 'Table Rebalancing',
    upcoming: 'Upcoming',
    in_progress: 'In Progress',
    finished: 'Finished',
    waiting_enough_players_to_start: 'Waiting for enough players to start',
    cancelled: 'Cancelled',

    too_many_rooms_description:
      '{{tournamentName}} will be started soon, but you have reached the maximum table amount, please leave at least 1 of the following tables to join {{tournamentName}}.',
    leave: 'Leave',
    sit_in: 'Sit In {{name}}',
    ignore: 'Ignore',

    re_entry_modal: {
      title: 'Re-enter Tournament?',
      description:
        '{{tournamentName}} is still open for joining, do you want to spend ${{ticketFee}} ticket fee to re-join the tournament?',
      re_enter: 'Re-enter',
      view_tournament: 'View Tournament',
    },
    waiting_for_players: {
      title: 'Waiting for Players',
      message: 'Waiting for {{count}} more player to join',
      message_plural: 'Waiting for {{count}} more players to join',
    },
    thanks_for_joining: {
      title: 'Thanks for Joining!',
      description: 'Thanks for joining {{tournamentName}}. The tournament is still ongoing, you can see your result later.',
      view_results: 'View Tournament Results',
    },
    cancel: {
      title: 'Tournament Cancelled',
      description: 'The tournament "{{tournamentName}}" has been cancelled.',
      refund_message: 'Your entry fee of ${{amount}} will be refunded.',
      confirm: 'OK',
    },
    waiting_timer: {
      title: 'Waiting for players',
      cancel_in: 'Cancel in',
    },
  },
  errorCodes: {
    default: {
      title: 'System Error',
      message: 'Something went wrong, please try again later',
    },

    WS_0000: 'System Error',
    WS_0001: 'Cannot join more than 4 rooms',
    WS_0002: 'Cannot quit room while placing the maximum bet among players',
    WS_0003: 'Verification error, please refresh the page and try again',
    WS_0004:
      'Detected some nearby person has joined the same room, therefore joining this room is forbidden at the moment',
    WS_0005: 'Cannot quit the player with the max bet. Please fold first',
    WS_0006: 'Buy in failed',
    WS_0007: 'Game room not found',

    HP_0001: 'Cannot join more than 4 rooms',
    HP_0002: 'Currently unable to establish server connection. Please try again later.',
    HP_0003: 'Insufficient funds to buy in',
    HP_0004: 'Invalid verification code',
    INVALID_EMAIL_PASS_CODE: 'Invalid verification code',
    INVALID_OTP: 'Invalid verification code',
    INVALID_REFERRAL_CODE: 'Invalid referral code',
    REFERRAL_CODE_ALREADY_USED: 'Referral code already used',
    INSUFFICIENT_COINS: 'Insufficient wallet balance',
    JOIN_TOURNAMENT_ERROR: 'Error joining tournament',
    LOCATION_CHECKING_FAILED: {
      PERMISSION_DENIED: 'Location access was denied.',
      POSITION_UNAVAILABLE: 'Location information is unavailable. Please try again later.',
      TIMEOUT: 'The request to get your location timed out. Please try again.',
      UNKNOWN: 'An unknown error occurred while requesting your location.',
    },
    TOURNAMENT_IS_FINISHED: 'Tournament is finished',
    GPS_RESTRICTION:
      'Location cannot be detected or a player near you has joined the same room, please try again later',
  },
};
